module.exports = __webpack_public_path__ + "img/Customer-Visits-Visiting-Customers5.50e33a9b.jpg";